import { CommonEnums } from '../../common.enums';

export class Obj_Db_Property {
    conn_Id: number;
    dbTyp_Id: number;
    el_Type: string;
    propertyType_Cd: string;
    property_Cd: string;
    propertyVal: string;
    defaultSel: string;
    streamingFlg: string;
    overrideFlg: string;
    obj_Id: number;
    dxMp_Inst_Id: number;
    dxFlow_Id: number;
    copyPropertyVal: string;

    srt_Order: number;
    copyDefaultSel: string;
    propertyNm: string;
    propertyVals: string;
    isEditable: string;
    validationRule: string;
    maxChars: number;
    description: string;
    defView: string;
    propertyValues: Array<string>;
    showOnProperty: string;
    showOnProperty_Val: string;
    showDbType_Id_Property: string;
    showDbType_Id_Property_Val: string;
    hasRules: string;
    hasValRules: string;
    showOnProperties: Map<string, string[]> = new Map<string, string[]>();
    showDbType_Id_Properties: Array<string>;
    showOnProperty_Values: Map<string, string[]> = new Map<string, string[]>();
    showDbType_Id_Property_Values: Map<string, string[]> = new Map<string, string[]>();
    showOn: boolean;
    dobj_Id: number;
    propertyReadOnly: string; //GETTER  property_ReadOnly_Level
    valid_Cd: string;
    relevant_DbTyp_Ids: string;
    fValue: string;
    sValue: string;
    propagateValue: string;
    change_Ind: string;
    property_level: string;
    operation: string;
    runAsOScommand: string;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.el_Type = CommonEnums.defaults.STRING_EMPTY; //TODO
        this.propertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.property_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.propertyVal = CommonEnums.defaults.STRING_EMPTY;
        this.propertyNm = CommonEnums.defaults.STRING_EMPTY;
        this.propertyVals = CommonEnums.defaults.STRING_EMPTY;
        this.isEditable = CommonEnums.defaults.STRING_EMPTY;
        this.validationRule = CommonEnums.defaults.STRING_EMPTY;
        this.maxChars = CommonEnums.defaults.LONG_VAL;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.defView = CommonEnums.defaults.STRING_EMPTY;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
        this.propertyValues = new Array<string>();
        this.defaultSel = CommonEnums.defaults.STRING_EMPTY;
        this.obj_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.copyPropertyVal = CommonEnums.defaults.STRING_EMPTY;
        this.copyDefaultSel = CommonEnums.defaults.STRING_EMPTY;
        this.showOnProperty = CommonEnums.defaults.STRING_EMPTY;
        this.showOnProperty_Val = CommonEnums.defaults.STRING_EMPTY;
        this.showDbType_Id_Property = CommonEnums.defaults.STRING_EMPTY;
        this.showDbType_Id_Property_Val = CommonEnums.defaults.STRING_EMPTY;
        this.hasRules = CommonEnums.defaults.STRING_EMPTY;
        this.hasValRules = CommonEnums.defaults.STRING_EMPTY;
        this.showOnProperties = new Map(); //TODO
        this.showDbType_Id_Properties = new Array<string>();
        this.showOnProperty_Values = new Map(); //TODO
        this.showDbType_Id_Property_Values = new Map(); //TODO
        this.showOn = true;
        this.streamingFlg = CommonEnums.defaults.STRING_EMPTY;
        this.dobj_Id = CommonEnums.defaults.LONG_VAL;
        this.propertyReadOnly = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.relevant_DbTyp_Ids = CommonEnums.defaults.STRING_EMPTY;
        this.fValue = CommonEnums.defaults.STRING_EMPTY;
        this.sValue = CommonEnums.defaults.STRING_EMPTY;
        this.overrideFlg = CommonEnums.defaults.STRING_EMPTY;
        this.propagateValue = CommonEnums.defaults.STRING_EMPTY;
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.property_level = CommonEnums.defaults.STRING_EMPTY;
        this.operation = CommonEnums.defaults.STRING_EMPTY;
        this.runAsOScommand = CommonEnums.defaults.STRING_VAL_NO;
    }

    static parse(obj_Db_PropertyTmp: Obj_Db_Property): Obj_Db_Property {
        let obj_Db_Property: Obj_Db_Property = new Obj_Db_Property();
        obj_Db_Property.copyFrom(obj_Db_PropertyTmp);
        return obj_Db_Property;
    }

    getPrimaryKey(): string {
        return this.conn_Id + '.' + this.dbTyp_Id + '.' + this.el_Type + '.' + this.propertyType_Cd + '.' + this.property_Cd +
            '.' + this.obj_Id + '.' + this.dxMp_Inst_Id + '.' + this.dxFlow_Id + '.' + this.dobj_Id;
    }

    copy(): Obj_Db_Property {
        let obj_Db_PropertyTmp: Obj_Db_Property = new Obj_Db_Property();

        obj_Db_PropertyTmp.conn_Id = this.conn_Id;
        obj_Db_PropertyTmp.dbTyp_Id = this.dbTyp_Id;
        obj_Db_PropertyTmp.el_Type = this.el_Type;
        obj_Db_PropertyTmp.propertyType_Cd = this.propertyType_Cd;
        obj_Db_PropertyTmp.property_Cd = this.property_Cd;
        obj_Db_PropertyTmp.propertyVal = this.propertyVal;
        obj_Db_PropertyTmp.defaultSel = this.defaultSel;
        obj_Db_PropertyTmp.streamingFlg = this.streamingFlg;
        obj_Db_PropertyTmp.overrideFlg = this.overrideFlg;
        obj_Db_PropertyTmp.obj_Id = this.obj_Id;
        obj_Db_PropertyTmp.dxMp_Inst_Id = this.dxMp_Inst_Id;
        obj_Db_PropertyTmp.dxFlow_Id = this.dxFlow_Id;
        obj_Db_PropertyTmp.copyPropertyVal = this.copyPropertyVal;
        obj_Db_PropertyTmp.srt_Order = this.srt_Order;
        obj_Db_PropertyTmp.copyDefaultSel = this.copyDefaultSel;
        obj_Db_PropertyTmp.propertyNm = this.propertyNm;
        obj_Db_PropertyTmp.propertyVals = this.propertyVals;
        obj_Db_PropertyTmp.isEditable = this.isEditable;
        obj_Db_PropertyTmp.validationRule = this.validationRule;
        obj_Db_PropertyTmp.maxChars = this.maxChars;
        obj_Db_PropertyTmp.showOnProperty_Val = this.showOnProperty_Val;
        obj_Db_PropertyTmp.description = this.description;
        obj_Db_PropertyTmp.defView = this.defView;
        obj_Db_PropertyTmp.propertyValues = this.propertyValues;
        obj_Db_PropertyTmp.showOnProperty = this.showOnProperty;
        obj_Db_PropertyTmp.showDbType_Id_Property = this.showDbType_Id_Property;
        obj_Db_PropertyTmp.showDbType_Id_Property_Val = this.showDbType_Id_Property_Val;
        obj_Db_PropertyTmp.hasRules = this.hasRules;
        obj_Db_PropertyTmp.hasValRules = this.hasValRules;
        obj_Db_PropertyTmp.showOnProperties = this.showOnProperties;
        obj_Db_PropertyTmp.showDbType_Id_Properties = this.showDbType_Id_Properties;

        obj_Db_PropertyTmp.showOnProperty_Values = this.showOnProperty_Values;
        obj_Db_PropertyTmp.showDbType_Id_Property_Values = this.showDbType_Id_Property_Values;
        obj_Db_PropertyTmp.showOn = this.showOn
        obj_Db_PropertyTmp.dobj_Id = this.dobj_Id;
        obj_Db_PropertyTmp.propertyReadOnly = this.propertyReadOnly;
        obj_Db_PropertyTmp.valid_Cd = this.valid_Cd;
        obj_Db_PropertyTmp.relevant_DbTyp_Ids = this.relevant_DbTyp_Ids;
        obj_Db_PropertyTmp.fValue = this.fValue;
        obj_Db_PropertyTmp.sValue = this.sValue;
        obj_Db_PropertyTmp.propagateValue = this.propagateValue;
        obj_Db_PropertyTmp.change_Ind = this.change_Ind;
        obj_Db_PropertyTmp.property_level = this.property_level;
        obj_Db_PropertyTmp.operation = this.operation;
        obj_Db_PropertyTmp.runAsOScommand = this.runAsOScommand;

        return obj_Db_PropertyTmp;
    }

    copyFrom(obj_Db_PropertyTmp: Obj_Db_Property): void {
        this.conn_Id = obj_Db_PropertyTmp.conn_Id;
        this.dbTyp_Id = obj_Db_PropertyTmp.dbTyp_Id;
        this.el_Type = obj_Db_PropertyTmp.el_Type;
        this.propertyType_Cd = obj_Db_PropertyTmp.propertyType_Cd;
        this.property_Cd = obj_Db_PropertyTmp.property_Cd;
        this.propertyVal = obj_Db_PropertyTmp.propertyVal;
        this.defaultSel = obj_Db_PropertyTmp.defaultSel;
        this.streamingFlg = obj_Db_PropertyTmp.streamingFlg;
        this.overrideFlg = obj_Db_PropertyTmp.overrideFlg;
        this.obj_Id = obj_Db_PropertyTmp.obj_Id;
        this.dxMp_Inst_Id = obj_Db_PropertyTmp.dxMp_Inst_Id;
        this.dxFlow_Id = obj_Db_PropertyTmp.dxFlow_Id;
        this.copyPropertyVal = obj_Db_PropertyTmp.copyPropertyVal;
        this.srt_Order = obj_Db_PropertyTmp.srt_Order;
        this.copyDefaultSel = obj_Db_PropertyTmp.copyDefaultSel;
        this.propertyNm = obj_Db_PropertyTmp.propertyNm;
        this.propertyVals = obj_Db_PropertyTmp.propertyVals;
        this.isEditable = obj_Db_PropertyTmp.isEditable;
        this.validationRule = obj_Db_PropertyTmp.validationRule;
        this.maxChars = obj_Db_PropertyTmp.maxChars;
        this.showOnProperty_Val = obj_Db_PropertyTmp.showOnProperty_Val;
        this.description = obj_Db_PropertyTmp.description;
        this.defView = obj_Db_PropertyTmp.defView;
        this.propertyValues = obj_Db_PropertyTmp.propertyValues;
        this.showOnProperty = obj_Db_PropertyTmp.showOnProperty;
        this.showDbType_Id_Property = obj_Db_PropertyTmp.showDbType_Id_Property;
        this.showDbType_Id_Property_Val = obj_Db_PropertyTmp.showDbType_Id_Property_Val;
        this.hasRules = obj_Db_PropertyTmp.hasRules;
        this.hasValRules = obj_Db_PropertyTmp.hasValRules;
        this.showOnProperties = obj_Db_PropertyTmp.showOnProperties;
        this.showDbType_Id_Properties = obj_Db_PropertyTmp.showDbType_Id_Properties;
        this.showDbType_Id_Properties = obj_Db_PropertyTmp.showDbType_Id_Properties;
        this.showOnProperty_Values = obj_Db_PropertyTmp.showOnProperty_Values;
        this.showDbType_Id_Property_Values = obj_Db_PropertyTmp.showDbType_Id_Property_Values;
        this.showOn = obj_Db_PropertyTmp.showOn;
        this.dobj_Id = obj_Db_PropertyTmp.dobj_Id;
        this.propertyReadOnly = obj_Db_PropertyTmp.propertyReadOnly;
        this.valid_Cd = obj_Db_PropertyTmp.valid_Cd;
        this.relevant_DbTyp_Ids = obj_Db_PropertyTmp.relevant_DbTyp_Ids;
        this.fValue = obj_Db_PropertyTmp.fValue;
        this.sValue = obj_Db_PropertyTmp.sValue;
        this.propagateValue = obj_Db_PropertyTmp.propagateValue;
        this.change_Ind = obj_Db_PropertyTmp.change_Ind;
        this.property_level = obj_Db_PropertyTmp.property_level;
        this.operation = obj_Db_PropertyTmp.operation;
        this.runAsOScommand = obj_Db_PropertyTmp.runAsOScommand;
    }

    compare(obj_Db_PropertyTmp: Obj_Db_Property): string {
        let obj_Db_PropertyString: string = this.toString(false);
        let obj_Db_PropertyTmpString: string = obj_Db_PropertyTmp.toString(false);

        if (obj_Db_PropertyString != obj_Db_PropertyTmpString) {
            return obj_Db_PropertyString + ', ' + obj_Db_PropertyTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Obj_Db_Property [conn_Id=" + this.conn_Id + ", dbTyp_Id=" + this.dbTyp_Id +
            ", el_Type=" + this.el_Type + ", propertyType_Cd=" + this.propertyType_Cd +
            ", property_Cd=" + this.property_Cd + ", propertyVal=" + this.propertyVal + ", defaultSel=" + this.defaultSel + ", streamingFlg=" + this.streamingFlg +
           ", obj_Id=" + this.obj_Id + ",dxMp_Inst_Id=" + this.dxMp_Inst_Id +
            ", dxFlow_Id=" + this.dxFlow_Id + ", copyPropertyVal=" + this.copyPropertyVal + ", srt_Order=" + this.srt_Order +
            ", copyDefaultSel=" + this.copyDefaultSel + ", propertyNm=" + this.propertyNm +
            ", propertyVals=" + this.propertyVals + ", isEditable=" + this.isEditable + ", validationRule=" + this.validationRule + ", maxChars=" + this.maxChars +
            ", description=" + this.description + ",defView=" + this.defView +
            ", propertyValues=" + this.propertyValues + ", showOnProperty=" + this.showOnProperty +
            ", showDbType_Id_Property=" + this.showDbType_Id_Property + ", showDbType_Id_Property_Val=" + this.showDbType_Id_Property_Val +
            ", dobj_Id=" + this.dobj_Id +
            ", propertyReadOnly=" + this.propertyReadOnly + ", valid_Cd=" + this.valid_Cd + ",relevant_DbTyp_Ids=" + this.relevant_DbTyp_Ids +
            ", fValue=" + this.fValue + ", sValue=" + this.sValue + ", propagateValue=" + this.propagateValue +
            ", property_level=" + this.property_level + ", showOnProperties=" + this.showOnProperties +
            ", showOnProperty_Values=" + this.showOnProperty_Values + ", showDbType_Id_Property_Values=" + this.showDbType_Id_Property_Values +
            ", operation=" + this.operation + ", runAsOScommand=" + this.runAsOScommand;

        if (isNotCompare) {
            str += ", hasRules=" + this.hasRules + ", hasValRules=" + this.hasValRules + ", showOn=" + this.showOn +
                ", showOnProperty_Val=" + this.showOnProperty_Val + ", change_Ind=" + this.change_Ind;
        }

        str += "]";
        return str;
        //  ", overrideFlg=" + this.overrideFlg + 
    }
}